define('v3/Common/Bindings/Carousel.Binding',['lodash', 'jquery', 'knockout', 'slick'], function (_, $, ko) {
	ko.bindingHandlers.carousel = {
		update: function (element, valueAccessor) {
			var config = ko.unwrap(valueAccessor());
			var variableWidth = config.variableWidth || false;
			var swipe = !(config.swipe === false);
			var adaptiveHeight = !(config.adaptiveHeight === false);
			var slidesToShow = config.slidesToShow || 1;

			if (config.init()) {
				setTimeout(function () {
					var activeElement = $(element).find('.active');
					var activeCard = $(element).children('.card-carousel-item').index(activeElement);

					$(element)
						.on('init', function (event, slick) {
							if (typeof config.initCallback === 'function') {
								config.initCallback(slick);
							}
						})
						.slick({
							adaptiveHeight: adaptiveHeight,
							initialSlide: activeCard === -1 ? 0 : activeCard,
							slidesToShow: slidesToShow,
							slidesToScroll: slidesToShow,
							autoplay: false,
							arrows: false,
							infinite: false,
							pauseOnFocus: false,
							pauseOnHover: false,
							variableWidth: variableWidth,
							swipe: swipe,
							slide: '.card-carousel-item'
						})
						.on('click', function (event) {
							var $target = $(event.target);
							var $slide = $target.hasClass('card') ? $target : $target.parents('.card');

							if ($slide.length > 0) {
								$slide.trigger('navigate');
							} else {
								$target.parents('.slick-slide').trigger('navigate');
							}
						})
						.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
							var $slide = $(slick.$slides[nextSlide]);

							$slide.trigger('getCardData');
							checkPreviousAndNext(nextSlide);
						})
						.on('refresh', function () {
							// Do not use slick's refresh method.
							// It enables autoPlay functionality while it's turned off
							var currentCard = $(element).slick('slickCurrentSlide');
							$(element).slick('slickGoTo', currentCard, true);
						});

					if (config.beforeChange) {
						$(element).on('beforeChange', function () {
							config.beforeChange.call();
						});
					}

					if (config.afterChange) {
						$(element).on('afterChange', function () {
							config.afterChange.call();
						});
					}

					function checkPreviousAndNext (currentCard) {
						var totalCards = $(element).prop('slick').$slides.length - 1;

						if (config.next) {
							config.next(!(totalCards === currentCard));
						}

						if (config.previous) {
							config.previous(!(currentCard === 0));
						}
					}
					checkPreviousAndNext(activeCard === -1 ? 0 : activeCard);
				}, 0);
			}
		}
	};
});

